'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/*

--- TODO :

- row selection
    - improve system to remove per-row watch
    - implement allowUnselect
    - implement multipleSelection

- sorting
    - clean itSortFactory
    - custom sorting function
    - add sortAttribute
    - check if sortType exists and warn if not

- allow smarter way to select a row than with the onRowClick handler
- allow to disable scroll mode ( more gracefully than with width : 1000000px ... )
- pagination mode ?
- column sizing with minWidth / width / maxWidth approach ?
- optimise rendering
- regroup config option in sub objects
- add tests
- massive cleanup
- remove console.log's

 */

ngModule.directive('infiniTable', function ($debounce, keyCodes, itKeyboardControls, itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "$tableCtrl",
    template: '' + '<div class="infini-table" tabindex="0">' + '   <div class="it-head">' + '       <table class="it-head-table">' + '           <colgroup></colgroup>' + '           <thead></thead>' + '       </table>' + '   </div>' + '   <div class="it-body">' + '       <div class="it-scroll-container" style="height:100%; width:100%; overflow:hidden;">' + '           <table class="it-body-table">' + '               <colgroup></colgroup>' + '               <thead>' + '                   <tr></tr>' + '               </thead>' + '               <tbody></tbody>' + '               <tfoot></tfoot>' + '           </table>' + '       </div>' + '       <div it-scrollbar></div>' + '   </div>' + '   <div class="it-foot">' + '       <table class="it-foot-table">' + '           <colgroup></colgroup>' + '           <tfoot></tfoot>' + '       </table>' + '   </div>' + '   <div class="it-horizontal-scroll" style="overflow-x: auto; overflow-y: hidden; height: 14px; display: none;">' + '       <div class="it-horizontal-scroll-content" style="height: 1px;"></div>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatchConfig, unwatchSource, unregisterTable;
      $attrs.$observe("tableConfig", function (tableConfigPropName) {
        initializeTableEvent();
        unwatchConfig = $scope.$parent.$watch(tableConfigPropName, function (tableConfig) {
          if (tableConfig == null) {
            return;
          }
          setTableConfig(tableConfig);
        });
      });
      var setTableConfig = function setTableConfig(config) {
        if (!config.id) {
          config.generatedId = true;
          config.id = _.uniqueId("infiniTable-");
        }
        ctrl.initializeTable(config);

        // unregister if required (reload) then register to the global table registry
        unregisterTable && unregisterTable();
        unregisterTable = itTableRegistry.register(config.id, ctrl);

        // stop previous source watcher if exists;
        unwatchSource && unwatchSource();

        // watch & observe dataSource
        unwatchSource = $scope.$parent.$watch(config.source, function (dataSource) {
          if (!dataSource) {
            return;
          }
          ctrl.setDatasource(dataSource);
        });
      };
      var initializeTableEvent = function initializeTableEvent() {
        // mousewheel scroll
        $el.mousewheel(function (event) {
          $scope.$apply(function () {
            var deltaY = event.deltaY;
            var deltaX = event.deltaX;
            if (deltaY !== 0) {
              var scrolled = ctrl.scroll.offset(deltaY > 0 ? -1 : 1);
              if (scrolled) {
                event.preventDefault();
              }
            }
            if (deltaX !== 0) {
              var horizontalScroll = ctrl.ui.horizontalScroll;
              if (horizontalScroll.is(':visible')) {
                var currentLeft = horizontalScroll.scrollLeft();
                var factor = event.deltaFactor || 20;
                horizontalScroll.scrollLeft(currentLeft + deltaX * factor);
                if (horizontalScroll.scrollLeft() !== currentLeft) {
                  event.preventDefault();
                }
              }
            }
          });
        });

        // keypress listener
        var keyboardControls = new itKeyboardControls(ctrl);

        /*
        var debouncedColumnSizing = $debounce(function() {
            ctrl.refreshColumnsSizing();
        }, 100);
         $scope.$on("$resize:required", debouncedColumnSizing);
        */
      };

      // ctrl cleanup on $destroy
      $scope.$on("$destroy", function () {
        ctrl.dispose();
        unregisterTable && unregisterTable();
        unwatchConfig && unwatchConfig();
        unwatchSource && unwatchSource();
      });
      $scope.$on("$resize", function () {
        ctrl.onResize();
      });
      $scope.$on("$redraw", function () {
        ctrl.refreshColumnsSizing();
      });
    },
    controller: "InfiniTableController"
  };
});
ngModule.controller("InfiniTableController", function ($scope, $element, $injector, itFooterManager, itSortFactory, itCompiler, itHeaderManager, itRowSelectionFeature, infiniTableConfigManager, itFooterAccumulator, UUID) {
  var ctrl = this;
  var stateManager = infiniTableConfigManager.getTableStateManager();

  // Accessors
  ctrl.getContext = function () {
    return context;
  };
  ctrl.getConfig = function () {
    return config;
  };
  ctrl.getScope = function () {
    return $scope;
  };
  ctrl.getElement = function () {
    return $element;
  };
  ctrl.getDataSource = function () {
    return dataSource;
  };
  ctrl.getRenderer = function () {
    return renderer;
  };
  ctrl.getCompiler = function () {
    return compiler;
  };
  ctrl.getScrollBar = function () {
    return scrollbar;
  };
  ctrl.linkers = {};
  var renderer,
    dataSource = [],
    autoresize = true,
    fullMode = false,
    config,
    scrollbar,
    /*
    true si affichage de la scrollbar horizontale
     */
    horizontalScrollbar,
    context = ctrl.context = {
      pagination: {},
      footerValues: {},
      sort: {}
    },
    ui = ctrl.ui = {
      table: $element,
      // head
      headDiv: $element.find(".it-head"),
      headTable: $element.find(".it-head table"),
      headColgroup: $element.find(".it-head table colgroup"),
      // content
      contentDiv: $element.find(".it-body"),
      contentScrollContainer: $element.find(".it-body .it-scroll-container"),
      contentTable: $element.find(".it-body table"),
      contentColgroup: $element.find(".it-body table colgroup"),
      contentHead: $element.find(".it-body table thead"),
      contentHeadRow: $element.find(".it-body table thead tr"),
      contentBody: $element.find(".it-body table tbody"),
      contentFoot: $element.find(".it-body table tfoot"),
      // footer
      footerDiv: $element.find(".it-foot"),
      footerTable: $element.find(".it-foot table"),
      footerColgroup: $element.find(".it-foot table colgroup"),
      // horizontal scroll
      horizontalScroll: $element.find(".it-horizontal-scroll"),
      horizontalScrollContent: $element.find(".it-horizontal-scroll-content")
    },
    compiler = ctrl.compiler = new itCompiler(ctrl),
    headerCtrl = new itHeaderManager(ctrl),
    footerCtrl = new itFooterManager(ctrl);
  var hasVisibilityManager = false,
    unbindVisibilityHandler = null,
    renderRequired = false,
    recomputeRequired = false;
  var tableState = null,
    isStateManaged = false;
  var autoScrollRaf = null,
    autoScrollSpeed = 0;
  function stopAutoScroll() {
    if (autoScrollRaf) {
      cancelAnimationFrame(autoScrollRaf);
      autoScrollRaf = null;
    }
    autoScrollSpeed = 0;
  }
  function onVisibilityChange(visible) {
    if (visible) {
      if (renderRequired) {
        setScrollPosition(lastScrollOptions);
        renderRequired = false;
      }
      if (recomputeRequired) {
        computeColumnSizing();
        recomputeRequired = false;
      }
      scrollbar.refresh(true);
    }
  }
  ctrl.isVisible = function () {
    if (hasVisibilityManager) {
      return config.visibilityManager.isVisible();
    } else {
      return true;
    }
  };
  ctrl.initializeTable = function (tableConfig) {
    if (unbindVisibilityHandler != null) {
      unbindVisibilityHandler();
    }
    if (renderer != null) {
      renderer.clearContent();
    }
    var tableType = tableConfig.type || "table";
    var rendererName = tableType === "tree" ? "itTreeRenderer" : "itTableRenderer";
    var rendererClass = $injector.get(rendererName);
    renderer = new rendererClass(ctrl);
    config = renderer.processConfiguration(tableConfig);

    // Add stickyColumnsCount to config
    config.stickyColumnsCount = tableConfig.stickyColumnsCount || 0;
    if (tableConfig.fullMode != null) {
      fullMode = tableConfig.fullMode;
    }

    // Ensure every column has a unique ID
    var usedIds = [];
    var _ensureIds = function ensureIds(cols) {
      _.each(cols, function (col, i) {
        if (col.group || col.columns) {
          if (!col.id) {
            var baseId = col.title ? 'group-' + col.title : 'group-' + i;
            var id = baseId;
            var ext = 0;
            while (usedIds.indexOf(id) > -1) {
              id = baseId + '-' + ext++;
            }
            col.id = id;
          }
          usedIds.push(col.id);
          _ensureIds(col.columns);
        } else {
          if (!col.id) {
            var _baseId = col.attribute ? 'col-' + col.attribute : 'col-' + i;
            var _id = _baseId;
            var _ext = 0;
            while (usedIds.indexOf(_id) > -1) {
              _id = _baseId + '-' + _ext++;
            }
            col.id = _id;
          }
          usedIds.push(col.id);
        }
      });
    };
    _ensureIds(config.columns);

    // Sauvegarde de la configuration originale des colonnes (ordre et largeurs)
    config.originalColumns = angular.copy(config.columns);
    config.originalWidths = {};
    var _collectOriginalWidths = function collectOriginalWidths(cols) {
      _.each(cols, function (col) {
        if (col.group || col.columns) {
          _collectOriginalWidths(col.columns);
        } else {
          config.originalWidths[col.id] = col.width;
        }
      });
    };
    _collectOriginalWidths(config.columns);

    // state manager
    if (config.stateManager != null) {
      stateManager = config.stateManager;
    }
    isStateManaged = stateManager.handleConfig(config);
    if (isStateManaged) {
      tableState = stateManager.getTableState(config.id);
    }
    if (tableState != null) {
      applyStateToConfig();
    }

    // defaut - si columnGroups alors par defaut à true, sinon à defaut à false
    horizontalScrollbar = config.columnGroups && config.columnGroups.length > 0;
    console.log('horizontalScrollbar', horizontalScrollbar, config);

    // active le "scroll horizontal" quand on a trop de colonnes affichées.
    if (config.horizontalScroll === true) {
      horizontalScrollbar = true;
    } else if (config.horizontalScroll === false) {
      horizontalScrollbar = false;
    }

    // visibility manager
    hasVisibilityManager = config.visibilityManager != null;
    if (hasVisibilityManager) {
      unbindVisibilityHandler = config.visibilityManager.onVisibilityChange(onVisibilityChange);
    }
    context.footerValues = {};
    compiler.compileTemplates();
    computeColumns(true);
    initializeHeaderAndFooter();
    initializeRowEvents(); // TODO : undelegate before re-applying (for config change / reload)

    if (config.allowSelection) {
      // TODO : undelegate before re-applying (for config change / reload)
      var rowSelectionFeature = new itRowSelectionFeature(ctrl);
      rowSelectionFeature.enable();
    }

    // PGA : the test is used for external height managers. // TODO : allow to enable / disable
    if (context.maxHeight == null) {
      ctrl.setHeight(config.height);
    }
  };
  function applyStateToConfig() {
    // ordre initial des colonnes
    if (tableState.columnsOrder != null && tableState.columnsOrder.length > 0) {
      config.columns = reorderColumnsWithSavedOrder(config.columns, tableState.columnsOrder);
    }

    // visibilité initiale des colonnes

    if (tableState.columnsVisibility != null) {
      console.log('apply tableState columnsVisibility', tableState.columnsVisibility, config);
      _.each(tableState.columnsVisibility, function (isColumnVisible, columnId) {
        var column = _.find(config.columns, {
          id: columnId
        });
        // console.log(isColumnVisible, columnId, column);
        if (column != null) {
          column.visible = isColumnVisible;
        }
      });
    }

    // visibilité initiale des groupes de colonnes.

    if (tableState.columnGroupsVisibility != null) {
      _.each(tableState.columnGroupsVisibility, function (isGroupVisible, groupId) {
        var columnGroup = _.find(config.columnGroups, {
          id: groupId
        });
        if (columnGroup != null) {
          columnGroup.visible = isGroupVisible;
        }
      });
    }

    // largeur initiale des colonnes
    if (tableState.columnsWidth != null) {
      _.each(tableState.columnsWidth, function (width, columnId) {
        var column = _.find(config.columns, {
          id: columnId
        });
        if (column != null) {
          column.width = width;
        }
      });
    }
  }

  /**
   * Retourne la liste des identifiants des colonnes sticky (les premières colonnes du tableau).
   */
  function getStickyColumnIds() {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0) {
      return [];
    }
    var ids = [];
    var count = 0;
    var cols = config.originalColumns || config.columns;
    var _collectStickyIds = function collectStickyIds(items) {
      for (var i = 0; i < items.length; i++) {
        if (count >= stickyCount) {
          break;
        }
        var item = items[i];
        if (item.group || item.columns) {
          _collectStickyIds(item.columns);
        } else {
          if (item.id) {
            ids.push(item.id);
          }
          count++;
        }
      }
    };
    _collectStickyIds(cols);
    return ids;
  }

  /**
   * Détermine si un identifiant ou un objet colonne/groupe correspond à un élément sticky.
   */
  function isSticky(idOrCol) {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0 || !idOrCol) {
      return false;
    }
    var stickyIds = getStickyColumnIds();
    if (_.isString(idOrCol)) {
      if (stickyIds.indexOf(idOrCol) > -1) {
        return true;
      }
      var topItem = findTopLevelItem(idOrCol);
      if (topItem && (topItem.group || topItem.columns)) {
        return _.some(topItem.columns, function (subCol) {
          return stickyIds.indexOf(subCol.id) > -1;
        });
      }
      return false;
    }
    if (idOrCol.id && stickyIds.indexOf(idOrCol.id) > -1) {
      return true;
    }
    if (idOrCol.group || idOrCol.columns) {
      return _.some(idOrCol.columns, function (subCol) {
        return stickyIds.indexOf(subCol.id) > -1;
      });
    }
    return false;
  }

  /**
   * Retourne le nombre d'éléments de premier niveau (colonnes top-level ou groupes)
   * correspondant aux colonnes sticky.
   */
  function getStickyTopLevelCount() {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0) {
      return 0;
    }
    var count = 0;
    var cols = config.originalColumns || config.columns;
    var topCount = 0;
    for (var i = 0; i < cols.length; i++) {
      if (count >= stickyCount) {
        break;
      }
      var item = cols[i];
      if (item.group || item.columns) {
        count += item.columns ? item.columns.length : 0;
      } else {
        count += 1;
      }
      topCount++;
    }
    return topCount;
  }

  /**
   * Réordonne la liste des colonnes de configuration selon un ordre sauvegardé dans le tableState.
   * Si de nouvelles colonnes ont été ajoutées dans le code (non présentes dans tableState),
   * elles sont replacées juste après la colonne qui les précédait dans la définition originale.
   * Les colonnes appartenant à un groupe restent au sein de ce groupe, et sont réordonnées à l'intérieur.
   * Les colonnes sticky (stickyColumnsCount) restent fixes en début de tableau et ne sont pas déplacées.
   */
  function reorderColumnsWithSavedOrder(configColumns, savedOrder) {
    if (!savedOrder || !savedOrder.length || !configColumns || !configColumns.length) {
      return configColumns;
    }
    var stickyTopCount = getStickyTopLevelCount();
    var stickyItems = [];
    var reorderableItems = configColumns;
    if (stickyTopCount > 0) {
      stickyItems = configColumns.slice(0, stickyTopCount);
      reorderableItems = configColumns.slice(stickyTopCount);
    }

    // 1. Réordonner les sous-colonnes à l'intérieur de chaque groupe réordonnable
    _.each(reorderableItems, function (item) {
      if (item.group || item.columns) {
        if (item.columns && item.columns.length > 0) {
          item.columns = reorderFlatColumns(item.columns, savedOrder);
        }
      }
    });

    // 2. Réordonner les éléments de premier niveau (colonnes et groupes)
    var reordered = reorderTopLevelColumns(reorderableItems, savedOrder);
    return stickyItems.concat(reordered);
  }
  function reorderFlatColumns(columnList, savedOrder) {
    var existingColMap = {};
    _.each(columnList, function (col) {
      existingColMap[col.id] = col;
    });
    var result = [];
    var placedColIds = {};

    // Ajouter les colonnes de l'ordre sauvegardé qui existent dans cette liste
    _.each(savedOrder, function (colId) {
      if (existingColMap[colId]) {
        result.push(existingColMap[colId]);
        placedColIds[colId] = true;
      }
    });

    // Insérer les colonnes non présentes dans le state sauvegardé
    _.each(columnList, function (col, i) {
      if (!placedColIds[col.id]) {
        var targetIdx = -1;
        for (var prevIdx = i - 1; prevIdx >= 0; prevIdx--) {
          var prevCol = columnList[prevIdx];
          var idxInResult = result.indexOf(prevCol);
          if (idxInResult !== -1) {
            targetIdx = idxInResult + 1;
            break;
          }
        }
        if (targetIdx !== -1) {
          result.splice(targetIdx, 0, col);
        } else {
          result.unshift(col);
        }
        placedColIds[col.id] = true;
      }
    });
    return result;
  }
  function reorderTopLevelColumns(configColumns, savedOrder) {
    function getFirstAppearanceIndex(item) {
      if (item.group || item.columns) {
        var minIdx = -1;
        _.each(item.columns, function (subCol) {
          var idx = savedOrder.indexOf(subCol.id);
          if (idx !== -1 && (minIdx === -1 || idx < minIdx)) {
            minIdx = idx;
          }
        });
        return minIdx;
      } else {
        return savedOrder.indexOf(item.id);
      }
    }
    var itemsWithSavedIndex = [];
    var unplacedItems = [];
    _.each(configColumns, function (item, originalIdx) {
      var savedIdx = getFirstAppearanceIndex(item);
      if (savedIdx !== -1) {
        itemsWithSavedIndex.push({
          item: item,
          savedIdx: savedIdx,
          originalIdx: originalIdx
        });
      } else {
        unplacedItems.push({
          item: item,
          originalIdx: originalIdx
        });
      }
    });
    itemsWithSavedIndex.sort(function (a, b) {
      return a.savedIdx - b.savedIdx;
    });
    var result = _.map(itemsWithSavedIndex, 'item');
    _.each(unplacedItems, function (unplaced) {
      var targetIdx = -1;
      for (var prevIdx = unplaced.originalIdx - 1; prevIdx >= 0; prevIdx--) {
        var prevItem = configColumns[prevIdx];
        var idxInResult = result.indexOf(prevItem);
        if (idxInResult !== -1) {
          targetIdx = idxInResult + 1;
          break;
        }
      }
      if (targetIdx !== -1) {
        result.splice(targetIdx, 0, unplaced.item);
      } else {
        result.unshift(unplaced.item);
      }
    });
    return result;
  }
  ctrl.setAutoResize = function (_autoresize) {
    autoresize = _autoresize;
  };
  ctrl.onResize = function () {
    if (autoresize) {
      ctrl.refreshColumnsSizing();
    }
  };
  ctrl.$setScrollbarCtrl = function (_scrollbarCtrl) {
    scrollbar = _scrollbarCtrl;
  };
  var computeColumns = function computeColumns(initial) {
    compiler.computeColumns(initial);
  };

  ///////////
  // Row events
  ///////////

  var initializeRowEvents = function initializeRowEvents() {
    var eventScope = config.eventApplyScope || $scope;
    var previousHover = null;

    // row mouseenter
    ui.contentBody.delegate("tr", "mouseenter", function (event) {
      var row = $(event.currentTarget);
      if (config.hoverClass) {
        if (previousHover) {
          previousHover.removeClass(config.hoverClass);
        }
        row.addClass(config.hoverClass);
        previousHover = row;
      }
      if (config.onRowEnter) {
        eventScope.$apply(function () {
          config.onRowEnter(row.scope().model, row);
        });
      }
    });

    // row mouseleave
    ui.contentBody.delegate("tr", "mouseleave", function (event) {
      var row = $(event.currentTarget);
      if (config.hoverClass) {
        row.removeClass(config.hoverClass);
      }
      if (config.onRowLeave) {
        eventScope.$apply(function () {
          config.onRowLeave(row.scope().model, row);
        });
      }
    });

    // onRowClick handler
    ui.contentBody.delegate("tr", "click", function (event) {
      if (config.onRowClick) {
        var row = $(event.currentTarget),
          model = row.scope().model;
        eventScope.$apply(function () {
          config.onRowClick(model, row);
        });
      }
    });
  };

  //////////
  // HEADER FUNCS
  //////////

  var initializeHeaderAndFooter = function initializeHeaderAndFooter() {
    headerCtrl.constructColGroups();
    headerCtrl.constructHeaders();
    footerCtrl.refreshStaticFooter();
    initializeColumnResizing();
    initializeColumnReordering();
  };

  /**
   * effectue le tri
   */
  ctrl.sortBy = function (columnIndexOrId, desc, options) {
    var silent = options != null && options.silent;
    // permet au suoustotal de ne pas modifier l'enregistrement du tri dans le contexte
    var noContextUpdate = options != null && options.noContextUpdate;

    // get the column
    var column = findColumnByIndexOrId(columnIndexOrId);
    if (column == null) {
      column = context.visibleColumns[0];
    }

    // sort dataSource.children columns (recusively)
    function recusiveTreeSort(dataSource, column, desc) {
      _.each(dataSource, function (l) {
        itSortFactory.sort(l.children, column, desc);
        // sort each children
        recusiveTreeSort(l.children, column, desc);
      });
    }

    // apply the sorting to the collection
    if (column.sortable) {
      itSortFactory.sort(dataSource, column.column, desc);

      // tree must sort children recusively
      if (config.type === 'tree') {
        recusiveTreeSort(dataSource, column.column, desc);
      }
    }

    // tri suivant le subtotalColumnId
    if (context.subtotal) {
      // retire les lignes de soustotal de la datasource
      _.remove(dataSource, {
        "__type__": "subtotal"
      });
      var subTotalColumn = findColumnByIndexOrId(context.subtotal.column);
      if (subTotalColumn != null) {
        var subTotalAttribute = subTotalColumn.column.attribute;
        if (subTotalColumn.column.subtotalGroupAttribute) {
          subTotalAttribute = subTotalColumn.column.subtotalGroupAttribute;
        }

        // on regroupe les données par la valeur de la colonne de sous-total
        // Note: groupBy preserve l'ordre des éléments, donc le tri effectué précédemment sur dataSource est conservé au sein des groupes.
        var groups = _.groupBy(dataSource, function (item) {
          return _.get(item, subTotalAttribute);
        });

        // on calcul l'aggrégat pour chaque groupe pour la colonne en cours de tri
        var groupList = _.map(groups, function (rows, key) {
          var aggregate = itFooterAccumulator.accumulate(rows, column.column);
          if (column.id === subTotalColumn.id) {
            aggregate = _.get(rows[0], subTotalAttribute);
          }
          return {
            key: key,
            rows: rows,
            aggregate: aggregate
          };
        });

        // on tri les groupes suivant l'aggrégat
        var aggregateColumnDef = _.extend({}, column.column, {
          id: 'aggregate',
          attribute: 'aggregate',
          comparator: undefined // on retire le comparateur car il s'attend à recevoir des lignes de données, et non des objets d'aggrégats
        });
        itSortFactory.sort(groupList, aggregateColumnDef, desc);

        // on remet à plat
        dataSource = [];
        _.each(groupList, function (group) {
          _.each(group.rows, function (row) {
            return dataSource.push(row);
          });
        });
        createSubtotalRowsInDatasource(subTotalColumn.column);
      }
    }

    // refresh the table
    refreshContent(config.keepIndexOnSort);

    // if state is managed, we update the state and persist it.
    if (isStateManaged && !silent) {
      tableState.sort = {
        column: columnIndexOrId,
        desc: desc || false
      };
      tableState.subtotalGroup = {
        column: context.subtotal ? context.subtotal.column : null
      };
      stateManager.setTableState(config.id, tableState);
    }
    if (!noContextUpdate) {
      // set context sort state
      context.sort = {
        // l'index de la colonne
        column: column.index,
        desc: desc
      };
    }
  };

  /**
   * indique la colonne de soustotal (ex: via un click sur la colonne de titreou un bouton)
   *  stock dans le context l'information (n'effectue aucune modification sur la datasource)
   */
  ctrl.subTotalBy = function (columnIndexOrId, options) {
    // get the column
    var column = findColumnByIndexOrId(columnIndexOrId);
    if (column == null) {
      column = context.visibleColumns[0];
      if (column == null) {
        console.error('Impossible de faire un sous total sur la colonne introuvable ', columnIndexOrId);
        return;
      }
    }
    if (context.subtotal && (context.subtotal.column === column.index || context.subtotal.column === column.id)) {
      context.subtotal.column = null;
    } else {
      var subtotalDesc = false;
      if (context.subtotal) {
        subtotalDesc = context.subtotal.desc;
      }
      // si la colonne de tri est la meme que la colonne de soustotal, alors on applique son sens de tri
      if (context.sort.column === column.id || context.sort.column === column.index) {
        subtotalDesc = context.sort.desc;
      }

      // set context sort state
      context.subtotal = {
        /**
         * id ou index de la colonne
         *
         */
        column: column.id || column.index,
        desc: subtotalDesc
      };
    }
  };
  function findColumnByIndexOrId(columnIndexOrId) {
    if (_.isNumber(columnIndexOrId)) {
      return _.find(context.columns, {
        index: columnIndexOrId
      });
    } else {
      return _.find(context.columns, {
        id: columnIndexOrId
      });
    }
  }
  ctrl.findColumnByIndexOrId = function (columnIndexOrId) {
    return findColumnByIndexOrId(columnIndexOrId);
  };

  //////////////
  // COLUMNS VISIBILITY
  //////////////

  /**
   *
   * @param columnIds
   * @param visible
   * @param optionalColumns si tru alors les columIds peuvent ne pas exister sur le tableau (colonnes dynamiques,
   * utilisé pour la lisye des versements sur les subvention) et donc on ne veut pas d'erreur pour ne pas les avoir trouvées.
   */
  function toggleColumnsVisibility(columnIds, visible, optionalColumns) {
    _.each(columnIds, function (columnId) {
      var column = _.find(context.columns, {
        id: columnId
      });
      if (!column) {
        if (!optionalColumns) {
          // la colonne n'a pas été trouvée, alors qu'elle est définie sur le tableau. Sans doute une erreur dans la declaration dans le js des colonnes du groupe
          console.error("Cant't find id " + columnId + " in context.columns", context.columns);
        }
      } else {
        column.column.visible = arguments.length >= 2 ? visible : !column.visible;
      }
    });
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
  }
  function isColumnGroupVisible(groupId) {
    var group = _.find(config.columnGroups, {
      id: groupId
    });
    var visibilityMap = ctrl.getColumnsVisibility();
    for (var i = 0; i < group.columns.length; i++) {
      if (visibilityMap[group.columns[i]] === false) {
        return false;
      }
    }
    return true;
  }
  ctrl.getColumnGroups = function () {
    return config.columnGroups;
  };
  ctrl.getColumnsVisibility = function () {
    var map = {};
    _.each(context.columns, function (column) {
      map[column.id] = column.visible;
    });
    return map;
  };
  ctrl.getColumnGroupsVisibility = function () {
    var map = {};
    _.each(config.columnGroups, function (group) {
      map[group.id] = isColumnGroupVisible(group.id);
    });
    return map;
  };

  /**
   * change la visiblité et rafraichi l'affichage
   * @param columnId
   * @param visible
   */
  ctrl.setColumnVisibility = function (columnId, visible) {
    var column = ctrl.findColumnByIndexOrId(columnId);
    toggleColumnsVisibility([columnId], visible);
  };
  ctrl.setGroupVisibility = function (groupId, visible) {
    var group = _.find(config.columnGroups, {
      id: groupId
    });
    if (!group) {
      console.error("Can't find group " + groupId);
    }
    toggleColumnsVisibility(group.columns, visible, group.optionalColumns);

    // if state is managed, we update the state and persist it.
    if (isStateManaged) {
      tableState.columnGroupsVisibility = ctrl.getColumnGroupsVisibility();
      stateManager.setTableState(config.id, tableState);
    }
  };

  /**
   * change la propriété visible de la colonne, sans relancer aucun recalcul/reaffichage
   * @param columnId
   * @param visible optionnel
   */
  ctrl.toggleColumnVisibility = function (columnId, visible) {
    var column = ctrl.findColumnByIndexOrId(columnId);
    if (visible !== undefined) {
      column.column.visible = visible;
    } else {
      column.column.visible = !column.column.visible;
    }
  };

  /**
   * Réinitialise les largeurs de toutes les colonnes à leur valeur par défaut
   * et purge cette donnée dans la persistance du TableState.
   */
  ctrl.resetColumnsSize = function () {
    if (isStateManaged && tableState) {
      tableState.columnsWidth = {};
      stateManager.setTableState(config.id, tableState);
    }
    if (config.originalWidths) {
      var _applyOriginalWidths = function applyOriginalWidths(cols) {
        _.each(cols, function (col) {
          if (col.group || col.columns) {
            _applyOriginalWidths(col.columns);
          } else if (config.originalWidths[col.id] !== undefined) {
            col.width = config.originalWidths[col.id];
          }
        });
      };
      _applyOriginalWidths(config.columns);
    }
    ctrl.refreshColumnsSizing();
  };

  /**
   * Réinitialise l'ordre de toutes les colonnes à leur configuration par défaut
   * et purge cette donnée dans la persistance du TableState.
   */
  ctrl.resetColumnsOrder = function () {
    if (isStateManaged && tableState) {
      delete tableState.columnsOrder;
      stateManager.setTableState(config.id, tableState);
    }
    if (config.originalColumns) {
      config.columns = angular.copy(config.originalColumns);
    }
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
    computeColumnSizing();
  };

  /**
   * Déplace une colonne ou un groupe de colonnes avant ou après un élément cible.
   * - Si l'élément est au premier niveau (colonne top-level ou groupe entier), il peut être déplacé
   *   par rapport à un autre élément du premier niveau (autre groupe ou colonne top-level).
   * - Si la colonne est à l'intérieur d'un groupe, elle ne peut être déplacée qu'au sein de ce même groupe.
   * - Les colonnes sticky ne peuvent pas être déplacées et aucune colonne ne peut être déplacée avant/parmi elles.
   * @param sourceId ID ou index de la colonne ou du groupe à déplacer
   * @param targetId ID ou index de la colonne ou du groupe cible
   * @param isBefore boolean Si true insère avant la cible, sinon après (défaut true)
   */
  ctrl.moveColumn = function (sourceId, targetId, isBefore) {
    if (isBefore === undefined) {
      isBefore = true;
    }
    if (!sourceId || !targetId || sourceId === targetId) {
      return;
    }
    if (isSticky(sourceId) || isSticky(targetId)) {
      return;
    }

    // 1. Vérifier s'il s'agit d'un déplacement au sein d'un même groupe
    var sourceLeaf = findColumnByIndexOrId(sourceId);
    var targetLeaf = findColumnByIndexOrId(targetId);
    if (sourceLeaf && targetLeaf && sourceLeaf.group && targetLeaf.group && sourceLeaf.group === targetLeaf.group) {
      var group = sourceLeaf.group;
      var fromIndex = _.findIndex(group.columns, function (col) {
        return col.id === sourceLeaf.id || col === sourceLeaf.column;
      });
      var toIndex = _.findIndex(group.columns, function (col) {
        return col.id === targetLeaf.id || col === targetLeaf.column;
      });
      if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
        return;
      }
      var movedCol = group.columns.splice(fromIndex, 1)[0];
      toIndex = _.findIndex(group.columns, function (col) {
        return col.id === targetLeaf.id || col === targetLeaf.column;
      });
      var insertIndex = isBefore ? toIndex : toIndex + 1;
      group.columns.splice(insertIndex, 0, movedCol);
      _onColumnsOrderChanged();
      return;
    }

    // Si l'une des feuilles appartient à un groupe et pas l'autre, ou à des groupes différents -> interdit
    if (sourceLeaf && sourceLeaf.group || targetLeaf && targetLeaf.group) {
      return;
    }

    // 2. Déplacement au niveau supérieur (top-level : colonnes sans groupe ou groupes entiers)
    var sourceTopItem = findTopLevelItem(sourceId, sourceLeaf);
    var targetTopItem = findTopLevelItem(targetId, targetLeaf);
    if (!sourceTopItem || !targetTopItem || sourceTopItem === targetTopItem) {
      return;
    }
    var stickyTopCount = getStickyTopLevelCount();
    var topFromIndex = config.columns.indexOf(sourceTopItem);
    var topToIndex = config.columns.indexOf(targetTopItem);
    if (topFromIndex === -1 || topToIndex === -1 || topFromIndex === topToIndex) {
      return;
    }
    if (topFromIndex < stickyTopCount || topToIndex < stickyTopCount) {
      return;
    }
    var movedTopItem = config.columns.splice(topFromIndex, 1)[0];
    topToIndex = config.columns.indexOf(targetTopItem);
    var topInsertIndex = isBefore ? topToIndex : topToIndex + 1;
    if (topInsertIndex < stickyTopCount) {
      config.columns.splice(topFromIndex, 0, movedTopItem);
      return;
    }
    config.columns.splice(topInsertIndex, 0, movedTopItem);
    _onColumnsOrderChanged();
  };
  ctrl.moveGroup = function (sourceGroupId, targetId, isBefore) {
    ctrl.moveColumn(sourceGroupId, targetId, isBefore);
  };
  function findTopLevelItem(idOrIndex, leafColumn) {
    if (leafColumn && !leafColumn.group && leafColumn.column) {
      var leafIdx = config.columns.indexOf(leafColumn.column);
      if (leafIdx !== -1) {
        return leafColumn.column;
      }
    }
    if (_.isNumber(idOrIndex)) {
      return config.columns[idOrIndex] || null;
    }
    return _.find(config.columns, function (item) {
      return item.id === idOrIndex || item === idOrIndex;
    }) || null;
  }
  function _onColumnsOrderChanged() {
    // Mise à jour et persistance du tableState
    if (isStateManaged) {
      if (!tableState) {
        tableState = {};
      }
      tableState.columnsOrder = ctrl.getColumnsOrder();
      stateManager.setTableState(config.id, tableState);
    }
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
    computeColumnSizing();
  }

  /**
   * Retourne la liste ordonnée des identifiants des colonnes
   */
  ctrl.getColumnsOrder = function () {
    var ids = [];
    var _collectIds = function collectIds(cols) {
      _.each(cols, function (col) {
        if (col.group || col.columns) {
          _collectIds(col.columns);
        } else if (col.id) {
          ids.push(col.id);
        }
      });
    };
    _collectIds(config.columns);
    return ids;
  };

  ////////

  var initializeColumnResizing = function initializeColumnResizing() {
    ui.headDiv.find('.it-resize-handle').remove();
    if (config.resizable !== true) {
      return;
    }
    _.each(context.visibleColumns, function (computedColumn) {
      if (!computedColumn) return;
      var th = ui.headTable.find('th[data-col-id="' + computedColumn.id + '"]');
      if (th.length === 0) return;
      var colDef = computedColumn.column;
      if (colDef.resizable === false) return;
      var handle = $('<div class="it-resize-handle" title="Redimensionner"></div>');
      handle.css({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: '6px',
        cursor: 'col-resize',
        'z-index': 500
      });
      if (th.css('position') === 'static') {
        th.css('position', 'relative');
      }
      th.append(handle);
      handle.on('click', function (e) {
        e.stopPropagation(); // Évite de déclencher le tri quand on relâche la souris sur la poignée
      });
      handle.on('dblclick', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $scope.$applyAsync(function () {
          colDef.width = config.originalWidths[colDef.id];
          if (isStateManaged && tableState && tableState.columnsWidth) {
            delete tableState.columnsWidth[colDef.id];
            stateManager.setTableState(config.id, tableState);
          }
          computeColumnSizing();
        });
      });
      var startX,
        startWidth,
        minW = 50,
        maxW = 1500;
      handle.on('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        startX = e.pageX;
        startWidth = computedColumn.width || th.outerWidth();
        var initialWidthStr = colDef.width;
        // Parsing des contraintes de la configuration colonne
        if (colDef.minWidth) {
          if (_.isNumber(colDef.minWidth)) minW = colDef.minWidth;else if (isPixelWidthRegexp.test(colDef.minWidth)) minW = parseInt(colDef.minWidth, 10);
        }
        if (colDef.maxWidth) {
          if (_.isNumber(colDef.maxWidth)) maxW = colDef.maxWidth;else if (isPixelWidthRegexp.test(colDef.maxWidth)) maxW = parseInt(colDef.maxWidth, 10);
        }
        var $doc = $(document);
        var rafId;

        // Injection d'une balise style pour forcer le curseur sur TOUS les éléments
        var $cursorStyle = $('#it-resize-cursor-style');
        if ($cursorStyle.length === 0) {
          $cursorStyle = $('<style id="it-resize-cursor-style"></style>').appendTo('head');
        }
        $cursorStyle.html('* { cursor: col-resize !important; user-select: none !important; }');
        handle.css('cursor', 'col-resize');
        var mousemoveHandler = function mousemoveHandler(eMove) {
          var deltaX = eMove.pageX - startX;
          var rawWidth = startWidth + deltaX;
          var newWidth = rawWidth;
          var currentCursor = 'col-resize';
          if (rawWidth <= minW) {
            newWidth = minW;
            currentCursor = 'not-allowed'; // Curseur interdit pour indiquer la limite atteinte
          } else if (rawWidth >= maxW) {
            newWidth = maxW;
            currentCursor = 'not-allowed'; // Curseur interdit pour indiquer la limite atteinte
          }
          $cursorStyle.html('* { cursor: ' + currentCursor + ' !important; user-select: none !important; }');
          handle.css('cursor', currentCursor);
          colDef.width = newWidth + 'px';

          // Optimisation du reflow à 60fps
          if (rafId) {
            cancelAnimationFrame(rafId);
          }
          rafId = requestAnimationFrame(function () {
            computeColumnSizing();
          });
        };
        var _mouseupHandler = function mouseupHandler(eUp) {
          $doc.off('mousemove', mousemoveHandler);
          $doc.off('mouseup', _mouseupHandler);

          // Restaure le comportement natif du curseur
          $cursorStyle.remove();
          handle.css('cursor', 'col-resize');
          if (rafId) {
            cancelAnimationFrame(rafId);
          }

          // On évite la mise à jour asynchrone et la sauvegarde serveur si on a juste cliqué sans modifier la largeur
          if (colDef.width === initialWidthStr) {
            return;
          }
          $scope.$applyAsync(function () {
            computeColumnSizing();

            // Rendu persistant du redimensionnement si le tableau supporte la gestion des états
            if (isStateManaged) {
              if (!tableState.columnsWidth) tableState.columnsWidth = {};
              tableState.columnsWidth[colDef.id] = colDef.width;
              stateManager.setTableState(config.id, tableState);
            }
          });
        };
        $doc.on('mousemove', mousemoveHandler);
        $doc.on('mouseup', _mouseupHandler);
      });
    });
  };
  var initializeColumnReordering = function initializeColumnReordering() {
    stopAutoScroll();
    $element.off('.it-reorder');
    ui.headTable.find('th').removeAttr('draggable').removeClass('it-reorderable it-dragging it-drop-target-left it-drop-target-right').off('.it-reorder');
    if (config.reorderable !== true) {
      return;
    }
    var draggedId = null;
    var draggedType = null; // 'group', 'top-column', or 'sub-column'
    var draggedGroup = null;
    function startAutoScroll() {
      if (!autoScrollRaf) {
        autoScrollRaf = requestAnimationFrame(autoScrollStep);
      }
    }
    function autoScrollStep() {
      if (autoScrollSpeed !== 0 && ui.horizontalScroll.is(':visible')) {
        var hs = ui.horizontalScroll[0];
        var currentScroll = ui.horizontalScroll.scrollLeft();
        var maxScroll = hs.scrollWidth - hs.clientWidth;
        var newScroll = Math.max(0, Math.min(maxScroll, currentScroll + autoScrollSpeed));
        if (newScroll !== currentScroll) {
          ui.horizontalScroll.scrollLeft(newScroll);
          ui.headDiv.scrollLeft(newScroll);
          ui.contentScrollContainer.scrollLeft(newScroll);
          ui.footerDiv.scrollLeft(newScroll);
        }
      }
      if (draggedId) {
        autoScrollRaf = requestAnimationFrame(autoScrollStep);
      } else {
        autoScrollRaf = null;
      }
    }
    function updateAutoScroll(e) {
      if (!draggedId || !ui.horizontalScroll.is(':visible')) {
        autoScrollSpeed = 0;
        return;
      }
      var clientX = e.originalEvent && e.originalEvent.clientX != null ? e.originalEvent.clientX : e.clientX;
      if (clientX == null) {
        return;
      }
      var headDivEl = ui.headDiv[0];
      if (!headDivEl) {
        autoScrollSpeed = 0;
        return;
      }
      var rect = headDivEl.getBoundingClientRect();
      var threshold = 60; // zone d'activation en pixels à partir du bord
      var minSpeed = 5;
      var maxSpeed = 25;

      // Calcul du bord gauche scrollable (après les éventuelles colonnes sticky)
      var leftBound = rect.left;
      var stickyCells = ui.headTable.find('.it-sticky-column');
      if (stickyCells.length > 0) {
        var maxStickyRight = rect.left;
        stickyCells.each(function () {
          var r = this.getBoundingClientRect();
          if (r.right > maxStickyRight) {
            maxStickyRight = r.right;
          }
        });
        leftBound = maxStickyRight;
      }
      var leftZone = leftBound + threshold;
      var rightZone = rect.right - threshold;
      if (clientX < leftZone) {
        var distance = Math.max(0, leftZone - clientX);
        var ratio = Math.min(1, distance / threshold);
        autoScrollSpeed = -(minSpeed + ratio * (maxSpeed - minSpeed));
      } else if (clientX > rightZone) {
        var distance = Math.max(0, clientX - rightZone);
        var ratio = Math.min(1, distance / threshold);
        autoScrollSpeed = minSpeed + ratio * (maxSpeed - minSpeed);
      } else {
        autoScrollSpeed = 0;
      }
    }
    $element.on('dragover.it-reorder', function (e) {
      updateAutoScroll(e);
    });
    $element.on('dragleave.it-reorder', function (e) {
      if (e.target === $element[0] || !$.contains($element[0], e.target)) {
        autoScrollSpeed = 0;
      }
    });

    // 1. En-têtes de groupe (th.it-group-cell)
    ui.headTable.find('th.it-group-cell').each(function () {
      var th = $(this);
      var groupId = th.attr('data-group-id');
      if (!groupId) return;
      if (isSticky(groupId)) {
        return;
      }
      th.addClass('it-reorderable');
      th.attr('draggable', 'true');
      th.on('dragstart.it-reorder', function (e) {
        draggedId = groupId;
        draggedType = 'group';
        draggedGroup = null;
        th.data('it-just-dragged', true);
        th.addClass('it-dragging');
        startAutoScroll();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.setData('text/plain', groupId);
          e.originalEvent.dataTransfer.effectAllowed = 'move';
        }
      });
      th.on('dragover.it-reorder', function (e) {
        updateAutoScroll(e);
        if (!draggedId || draggedId === groupId) {
          return;
        }
        if (isSticky(draggedId) || isSticky(groupId)) {
          return;
        }

        // Un groupe ne peut être déposé que sur un autre groupe ou sur une colonne top-level
        if (draggedType !== 'group' && draggedType !== 'top-column') {
          return;
        }
        e.preventDefault();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.dropEffect = 'move';
        }
        var rect = th[0].getBoundingClientRect();
        var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
        var isLeft = relX < rect.width / 2;
        if (isLeft) {
          th.addClass('it-drop-target-left').removeClass('it-drop-target-right');
        } else {
          th.addClass('it-drop-target-right').removeClass('it-drop-target-left');
        }
      });
      th.on('dragleave.it-reorder', function () {
        th.removeClass('it-drop-target-left it-drop-target-right');
      });
      th.on('dragend.it-reorder', function () {
        stopAutoScroll();
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
      th.on('drop.it-reorder', function (e) {
        stopAutoScroll();
        e.preventDefault();
        e.stopPropagation();
        th.removeClass('it-drop-target-left it-drop-target-right');
        var sourceId = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.getData('text/plain') : draggedId;
        if (!sourceId) {
          sourceId = draggedId;
        }
        if (sourceId && groupId && sourceId !== groupId) {
          if (isSticky(sourceId) || isSticky(groupId)) {
            return;
          }
          if (draggedType === 'group' || draggedType === 'top-column') {
            var rect = th[0].getBoundingClientRect();
            var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
            var isLeft = relX < rect.width / 2;
            $scope.$evalAsync(function () {
              ctrl.moveColumn(sourceId, groupId, isLeft);
            });
          }
        }
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
    });

    // 2. En-têtes de colonnes (th.it-header-cell)
    _.each(context.visibleColumns, function (computedColumn) {
      if (!computedColumn) return;
      var th = ui.headTable.find('th[data-col-id="' + computedColumn.id + '"]');
      if (th.length === 0) return;
      var colDef = computedColumn.column;
      if (colDef.reorderable === false) return;
      if (isSticky(computedColumn.id) || isSticky(computedColumn.column)) {
        return;
      }
      var isTopLevel = computedColumn.group == null;
      th.addClass('it-reorderable');
      th.attr('draggable', 'true');
      th.on('dragstart.it-reorder', function (e) {
        draggedId = computedColumn.id;
        draggedType = isTopLevel ? 'top-column' : 'sub-column';
        draggedGroup = computedColumn.group || null;
        th.data('it-just-dragged', true);
        th.addClass('it-dragging');
        startAutoScroll();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.setData('text/plain', computedColumn.id);
          e.originalEvent.dataTransfer.effectAllowed = 'move';
        }
      });
      th.on('dragover.it-reorder', function (e) {
        updateAutoScroll(e);
        if (!draggedId || draggedId === computedColumn.id) {
          return;
        }
        if (isSticky(draggedId) || isSticky(computedColumn.id) || isSticky(computedColumn.column)) {
          return;
        }
        if (isTopLevel) {
          // Cible = colonne de premier niveau : autorisée si l'élément déplacé est un groupe ou une colonne de premier niveau
          if (draggedType !== 'group' && draggedType !== 'top-column') {
            return;
          }
        } else {
          // Cible = sous-colonne : autorisée UNIQUEMENT si l'élément déplacé est une sous-colonne du MÊME groupe
          if (draggedType !== 'sub-column' || draggedGroup !== computedColumn.group) {
            return;
          }
        }
        e.preventDefault();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.dropEffect = 'move';
        }
        var rect = th[0].getBoundingClientRect();
        var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
        var isLeft = relX < rect.width / 2;
        if (isLeft) {
          th.addClass('it-drop-target-left').removeClass('it-drop-target-right');
        } else {
          th.addClass('it-drop-target-right').removeClass('it-drop-target-left');
        }
      });
      th.on('dragleave.it-reorder', function () {
        th.removeClass('it-drop-target-left it-drop-target-right');
      });
      th.on('dragend.it-reorder', function () {
        stopAutoScroll();
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
      th.on('drop.it-reorder', function (e) {
        stopAutoScroll();
        e.preventDefault();
        e.stopPropagation();
        th.removeClass('it-drop-target-left it-drop-target-right');
        var sourceId = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.getData('text/plain') : draggedId;
        if (!sourceId) {
          sourceId = draggedId;
        }
        var targetId = computedColumn.id;
        if (sourceId && targetId && sourceId !== targetId) {
          if (isSticky(sourceId) || isSticky(targetId) || isSticky(computedColumn.column)) {
            return;
          }
          var canDrop = false;
          if (isTopLevel) {
            if (draggedType === 'group' || draggedType === 'top-column') {
              canDrop = true;
            }
          } else {
            if (draggedType === 'sub-column' && draggedGroup === computedColumn.group) {
              canDrop = true;
            }
          }
          if (canDrop) {
            var rect = th[0].getBoundingClientRect();
            var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
            var isLeft = relX < rect.width / 2;
            $scope.$evalAsync(function () {
              ctrl.moveColumn(sourceId, targetId, isLeft);
            });
          }
        }
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
    });
  };
  var isPixelWidthRegexp = /px$/i;
  var isPercentageWidthRegexp = /%$/i;

  // Helper function to apply sticky styles to a single cell
  var _applyStickyStylesToCell = function _applyStickyStylesToCell(cell, columnIndex, cumulativeLeft, zIndexBase, bgColor, isLastStickyCol) {
    if (cell && cell.length) {
      // Ensure cell exists
      cell.css({
        'position': 'sticky',
        'left': cumulativeLeft + 'px',
        'z-index': zIndexBase - columnIndex,
        'border-right': isLastStickyCol ? '1px solid #cccccc' : '1px solid #E8E8E8',
        'transform': 'translateZ(0)',
        '-webkit-backface-visibility': 'hidden'
      }).addClass('it-sticky-column'); // Add class for CSS specificity support
      if (!cell.hasClass('it-subtotal-cell')) {
        cell.css({
          'background-color': bgColor || 'inherit'
        }); // Use explicit bgColor if provided, or inherit
      }
    }
  };

  // Expose this method for renderers to call on new rows
  ctrl.applyStickyStylesToRow = function (rowElement) {
    var stickyColumnsCount = config.stickyColumnsCount || 0;
    var cumulativeStickyWidth = 0;

    // Only apply if there are sticky columns configured
    if (stickyColumnsCount === 0) {
      return;
    }
    for (var colIdx = 0; colIdx < stickyColumnsCount; colIdx++) {
      var computedColumn = context.visibleColumns[colIdx];
      if (computedColumn && computedColumn.visible) {
        var cell = rowElement.find('> td').eq(colIdx);
        _applyStickyStylesToCell(cell, colIdx, cumulativeStickyWidth, 50, 'inherit', colIdx === stickyColumnsCount - 1); // Body rows inherit from TR for selection support
        cumulativeStickyWidth += computedColumn.width || 0; // Use the pre-calculated width
      }
    }
  };
  var computeColumnSizing = function computeColumnSizing() {
    if (!ctrl.isVisible()) {
      recomputeRequired = true;
      return;
    }
    var showScrollbar = context.pagination.full !== true,
      computedColumns = context.visibleColumns,
      // largeur disponible a l'écran pour afficher la table
      totalTableDivWidth = ui.contentDiv.width(),
      scrollbarWidth = config.scrollbarWidth,
      // largeur disponible a l'écran pour afficher la table - la taille des colonnes visibles de la table
      availableWidth = totalTableDivWidth,
      usedWidth = 0,
      requireAutosizing = false,
      i;
    if (showScrollbar) {
      availableWidth -= scrollbarWidth;
    }
    function setColumnWidth(index, width) {
      computedColumns[index].headerCol.width(width);
      computedColumns[index].contentCol.width(width);
      computedColumns[index].footerCol.width(width);
    }

    // sizing the scrollbar column
    if (showScrollbar) {
      scrollbar.show();
      ui.headColgroup.find(".scrollbar").width(scrollbarWidth);
      ui.contentColgroup.find(".scrollbar").width(scrollbarWidth);
      ui.footerColgroup.find(".scrollbar").width(scrollbarWidth);
      $element.removeClass("it-no-scrollbar");
    } else {
      scrollbar.hide();
      ui.headColgroup.find(".scrollbar").width(0);
      ui.contentColgroup.find(".scrollbar").width(0);
      ui.footerColgroup.find(".scrollbar").width(0);
      $element.addClass("it-no-scrollbar");
    }

    // First pass: Determine all column widths
    for (i = 0; i < computedColumns.length; i++) {
      var computedColumn = computedColumns[i],
        width = computedColumn.column.width || "auto",
        widthInPixel = null;
      if (_.isNumber(width)) {
        widthInPixel = width;
      } else if (isPixelWidthRegexp.test(width)) {
        widthInPixel = parseInt(width.substring(0, width.length - 2));
      } else if (isPercentageWidthRegexp.test(width)) {
        var percentage = parseInt(width.substring(0, width.length - 1));
        widthInPixel = percentage * totalTableDivWidth / 100;
      } else {
        // auto
        requireAutosizing = true;
      }
      if (widthInPixel != null) {
        availableWidth -= widthInPixel;
        usedWidth += widthInPixel;
        computedColumn.autowidth = false;
        computedColumn.width = widthInPixel; // Store the computed width
        setColumnWidth(i, widthInPixel);
      } else {
        setColumnWidth(i, ""); // Clear width for auto-sized columns initially
        computedColumn.autowidth = true;
      }
    }
    var hasHorizontalOverflow = availableWidth < 0;

    // console.log('availableWidth', availableWidth, 'hasHorizontalOverflow', hasHorizontalOverflow, 'usedWidth', usedWidth)
    var newTableWidth = usedWidth;
    if (showScrollbar) {
      newTableWidth += scrollbarWidth;
    }
    var widthFromColumns = 0;
    if (horizontalScrollbar) {
      // console.log('horizontalScrollbar for table', config.id);
      if (hasHorizontalOverflow) {
        // Case A: Fixed columns already overflow.
        if (requireAutosizing) {
          // Add fallback width for auto columns
          var autoColCount = _.filter(computedColumns, 'autowidth').length;
          // arbitrairement 100px par colonne autodimensionnable
          newTableWidth += autoColCount * 100;
          //            console.log('autoColCount', autoColCount);

          widthFromColumns = newTableWidth;
        } else {
          widthFromColumns = usedWidth;
        }
      } else if (requireAutosizing) {
        // Case B: Check if auto columns cause overflow
        var contentHeaders = ui.contentHeadRow.find("th");

        // Allow table to expand to fit content
        // We use max-content to ensure the table takes its natural width based on content,
        // ignoring the container's width constraint.
        ui.contentTable.css({
          "table-layout": "auto",
          "width": "max-content",
          "min-width": "100%"
        });
        ui.contentHeadRow.show();
        ui.contentFoot.show();
        var tableFullExpendWidth = ui.contentTable.width();

        // If actual width exceeds available width, we have overflow
        if (tableFullExpendWidth > totalTableDivWidth) {
          // console.log("actualWidth > availableWidth", tableFullExpendWidth, availableWidth)
          hasHorizontalOverflow = true;
          // inutile et inadapté je pense. Il faut recaculer avec les colonnes
          newTableWidth = tableFullExpendWidth;
        }
        if (hasHorizontalOverflow) {
          // console.log('computedColumns', computedColumns)
          // Capture widths for auto columns
          for (i = 0; i < computedColumns.length; i++) {
            if (computedColumns[i].visible) {
              if (computedColumns[i].autowidth) {
                var widthCol = contentHeaders.eq(i).width();
                // l'affichage du scrolling levant toute contrainte de largeur, un maxWidth evite qu'un champ ne s'étende trop.
                var currentColumn = computedColumns[i].column;
                if (currentColumn.maxWidth) {
                  // soit le nombre en px (100), soit  en chaine : '100px'
                  var maxWidth;
                  if (_.isNumber(currentColumn.maxWidth)) {
                    maxWidth = currentColumn.maxWidth;
                  } else if (isPixelWidthRegexp.test(currentColumn.maxWidth)) {
                    maxWidth = parseInt(currentColumn.maxWidth.substring(0, currentColumn.maxWidth.length - 2));
                  }
                  if (maxWidth && maxWidth < widthCol) {
                    widthCol = maxWidth;
                  }
                } else {
                  // on limite les colonnes à 500px de large par défaut
                  if (widthCol > 500) {
                    //   console.log('Limit widthCol to 500', computedColumns[i], widthCol);
                    widthCol = 500;
                  }
                }
                if (currentColumn.minWidth) {
                  // soit le nombre en px (100), soit  en chaine : '100px'
                  var minWidth;
                  if (_.isNumber(currentColumn.minWidth)) {
                    minWidth = currentColumn.minWidth;
                  } else if (isPixelWidthRegexp.test(currentColumn.minWidth)) {
                    minWidth = parseInt(currentColumn.minWidth.substring(0, currentColumn.minWidth.length - 2));
                  }
                  if (minWidth && minWidth > widthCol) {
                    widthCol = minWidth;
                  }
                }

                //console.log(computedColumns[i], widthCol)

                setColumnWidth(i, widthCol);
                computedColumns[i].width = widthCol; // Store calculated width for sticky calculations
                widthFromColumns += widthCol;
                //console.log('autoWidth ' + i, widthCol)
              } else {
                //console.log('use fixed width', computedColumns[i], computedColumns[i].width)

                widthFromColumns += computedColumns[i].width;
                //console.log('width ' + i, computedColumns[i].width)
              }
            }
          }
        }

        // Restore fixed layout
        ui.contentTable.css({
          "table-layout": "fixed"
        });
        ui.contentHeadRow.hide();
        ui.contentFoot.hide();
      } else {
        widthFromColumns = usedWidth;
      }
      if (hasHorizontalOverflow) {
        // console.log('actualWidth > availableWidth , newTableWidth, widthFromColumns ', actualWidth, availableWidth, newTableWidth, widthFromColumns, scrollbarWidth)
        newTableWidth = widthFromColumns + (showScrollbar ? scrollbarWidth : 0);
        // console.log('newTableWidth', newTableWidth, 'widthFromColumns', widthFromColumns)

        // si on occupe pas toute la place au final ?
        if (newTableWidth < totalTableDivWidth) {
          //   console.log('newTableWidth<totalTableDivWidth', newTableWidth, totalTableDivWidth)
          hasHorizontalOverflow = false;
        }
      }
      if (hasHorizontalOverflow) {
        //console.log('show horizontalScroll - newTableWidth', newTableWidth)
        ui.horizontalScroll.show();
        ui.horizontalScrollContent.width(newTableWidth);
        ui.headTable.width(newTableWidth);
        ui.contentTable.width(newTableWidth);
        ui.footerTable.width(newTableWidth);

        // Ensure containers hide overflow
        ui.headDiv.css('overflow-x', 'hidden');
        ui.contentScrollContainer.css('overflow-x', 'hidden');
        ui.footerDiv.css('overflow-x', 'hidden');

        // Bind scroll
        ui.horizontalScroll.off('scroll.horizontal').on('scroll.horizontal', function () {
          var left = $(this).scrollLeft();
          ui.headDiv.scrollLeft(left);
          ui.contentScrollContainer.scrollLeft(left);
          ui.footerDiv.scrollLeft(left);
        });
      } else {
        ui.horizontalScroll.hide();
        ui.headTable.css('width', '100%');
        ui.contentTable.css('width', '100%');
        ui.footerTable.css('width', '100%');
        ui.horizontalScroll.off('scroll.horizontal');

        // Reset scroll positions
        ui.headDiv.scrollLeft(0);
        ui.contentScrollContainer.scrollLeft(0);
        ui.footerDiv.scrollLeft(0);
      }
    } else {
      //  console.log("don't show horizontal scrollbar");
    }

    // Get computed background colors for header and footer once
    var headerBgColor = ui.headDiv.css('background-color') || 'white';
    var footerBgColor = ui.footerDiv.css('background-color') || 'white';

    // Apply sticky styles based on determined widths
    var stickyColumnsCount = hasHorizontalOverflow ? config.stickyColumnsCount || 0 : 0;
    var cumulativeStickyWidth = 0;

    // Force separate borders for sticky reliability
    if (stickyColumnsCount > 0) {
      ui.headTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
      ui.contentTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
      ui.footerTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
    } else {
      // Reset to default if no sticky columns
      ui.headTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
      ui.contentTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
      ui.footerTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
    }

    // Reset sticky styles for all cells before re-applying (but NOT background-color here, handled individually)
    $element.find('.it-head-table th, .it-head-table td, .it-body-table td, .it-foot-table td').css({
      'position': '',
      'left': '',
      'z-index': '',
      'border-right': '',
      'transform': '',
      '-webkit-backface-visibility': ''
    });
    var _loop = function _loop() {
        computedColumn = computedColumns[i];
        currentColumnWidth = computedColumn.width;
        if (i < stickyColumnsCount) {
          var leftPos = cumulativeStickyWidth;

          // L'utilisation de zIndexBase différents pour l'en-tête (100), le pied de page (75) et le corps (50) est essentielle pour gérer la superposition verticale du tableau, en plus de la superposition horizontale des colonnes "sticky".

          // Apply to it-head
          // Pour le moment cela ne marche bien que si les stickys ne sont pas des colonnes au sein de groupe. Donc définis sur le premier tr.
          ui.headTable.find('tr:first').each(function () {
            var cell = $(this).find('> th, > td').eq(i);
            _applyStickyStylesToCell(cell, i, leftPos, 100, headerBgColor, i === stickyColumnsCount - 1); // Explicit color for header
          });

          // Apply to it-body (existing rows)
          ui.contentTable.find('> tbody > tr').each(function () {
            // Target tbody rows specifically
            var rowElement = $(this);
            var cell = rowElement.find('> td').eq(i);
            _applyStickyStylesToCell(cell, i, leftPos, 50, 'inherit', i === stickyColumnsCount - 1); // Inherit for body (selection support)
          });

          // Apply to it-foot
          if (config.footer) {
            ui.footerTable.find('tr').each(function () {
              var cell = $(this).find('> th, > td').eq(i);
              _applyStickyStylesToCell(cell, i, leftPos, 75, footerBgColor, i === stickyColumnsCount - 1); // Explicit color for footer
            });
          }
          cumulativeStickyWidth += currentColumnWidth || 0;
        } else {
          // Remove sticky class and background-color if it was previously sticky
          var nonStickyCell = $element.find('.it-head-table tr, .it-body-table tr, .it-foot-table tr').find('> th, > td').eq(i);
          nonStickyCell.removeClass('it-sticky-column').css('background-color', '');
        }
      },
      computedColumn,
      currentColumnWidth;
    for (i = 0; i < computedColumns.length; i++) {
      _loop();
    }
    ctrl.applyUsedHeight();
    if (scrollbar) {
      scrollbar.refresh(true);
    }
  };
  ctrl.enableFullMode = function () {
    fullMode = true;
    setScrollPosition({
      full: true
    });
    computeColumnSizing();
  };
  ctrl.disableFullMode = function () {
    fullMode = false;
    setScrollPosition({
      index: 0,
      initial: false
    });
    computeColumnSizing();
  };
  ctrl.refreshColumnsSizing = function () {
    if (config == null) {
      return;
    }
    computeColumnSizing();
  };

  //////////
  // HEIGHT SIZING
  //////////

  ctrl.setHeight = function (height, redraw) {
    context.maxHeight = height;
    if (redraw && dataSource && renderer) {
      // ctrl.applyMaxAvailableHeight(); // TODO : useful ?
      ctrl.scroll.toIndex(context.pagination && context.pagination.first || 0);
      computeColumnSizing();
      scrollbar.refresh(true);
      // ctrl.applyUsedHeight();
    }
  };

  /**
   * Compute the total height available for the table body. ( aka table height minus header / footer height )
   *
   * @returns {Number} the available height or null if there is no height limitation.
   */
  ctrl.getAvailableBodyHeight = function () {
    if (context.maxHeight) {
      // TODO : might want to compute this only once. (+ compute border instead of hardcoded -1)
      var headerHeight = ui.headDiv.height() - 2;
      var footerHeight = footerCtrl.hasStaticFooter(config) ? ui.footerDiv.height() + 3 : 2;
      var available = context.maxHeight - headerHeight - footerHeight;
      if (ui.horizontalScroll.is(":visible")) {
        available -= ui.horizontalScroll.outerHeight();
      }
      return available;
    } else {
      return null;
    }
  };

  /**
   * Inner method,
   */
  ctrl.applyUsedHeight = function () {
    var filled = context.pagination.filled;
    var full = context.pagination.full;
    if (fullMode) {
      ui.contentDiv.css("height", "auto");
    } else if (filled && !full) {
      var availableHeight = ctrl.getAvailableBodyHeight();
      ui.contentDiv.height(availableHeight);
    } else {
      ui.contentDiv.height(ui.contentTable.height());
    }
  };

  //////////
  /// SCROLL
  //////////

  ctrl.scroll = {
    toIndex: function toIndex(index) {
      return setScrollPosition({
        index: index
      });
    },
    toTop: function toTop() {
      return setScrollPosition({
        index: 0
      });
    },
    toBottom: function toBottom() {
      return setScrollPosition({
        index: renderer.getActualLength() - 1
      });
    },
    toPercent: function toPercent(percent) {
      if (percent === 100) {
        return ctrl.scroll.toBottom();
      } else if (percent === 0) {
        return ctrl.scroll.toTop();
      } else {
        var itemIdx = Math.round(percent / 100 * (renderer.getActualLength() - context.pagination.count));
        return setScrollPosition({
          index: itemIdx
        });
      }
    },
    pageUp: function pageUp() {
      return ctrl.scroll.offset(-(context.pagination.count - 1));
    },
    pageDown: function pageDown() {
      return ctrl.scroll.offset(context.pagination.count - 1);
    },
    offset: function offset(count) {
      var firstIdx = context.pagination.first,
        lastIdx = context.pagination.last,
        actualLength = renderer.getActualLength(),
        scrollTo;
      if (count < 0 ? firstIdx === 0 : lastIdx === actualLength - 1) {
        return false;
      }
      if (lastIdx + count >= actualLength - 1) {
        scrollTo = actualLength - 1;
      } else {
        scrollTo = count > 0 ? Math.min(firstIdx + count, actualLength - 1) : Math.max(firstIdx + count, 0);
      }
      return setScrollPosition({
        index: scrollTo
      });
    }
  };
  ctrl.refreshContent = function () {
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
  };

  //////////
  /// RENDER
  //////////

  function createSubtotalRowsInDatasource(subTotalColumn) {
    var i = 0,
      subtotalBeginingPosition = 0;
    var subTotalAttribute = subTotalColumn.attribute;
    if (subTotalColumn.subtotalGroupAttribute) {
      subTotalAttribute = subTotalColumn.subtotalGroupAttribute;
    }
    var sortedDatasource = [];

    // liste des lignes avec la meme valeur
    var subtotalDatasource = [];
    context.subtotalValues = [];
    while (i <= dataSource.length) {
      //        dataSource.
      if (i > 0) {
        var previousVal = _.get(dataSource[i - 1], subTotalAttribute);
        var comparaison = -1;
        // si on est pas ser la dernière ligne
        if (i < dataSource.length) {
          comparaison = itSortFactory.getColumnComparator(subTotalColumn, subTotalAttribute)(dataSource[i - 1], dataSource[i]);
        }
        if (comparaison !== 0) {
          // identifiant unique pour la ligne de sous-total
          var uuid = UUID();
          var subtotalRow = {
            __type__: 'subtotal',
            "__refValue__": previousVal,
            // on passe le filter de la valeur de référence, pour l'affichage dans la ligne de total
            "__refValueFilter__": subTotalColumn.filter,
            "__refColumn__": subTotalColumn,
            "__columnId__": subTotalColumn.id,
            "id": uuid,
            // reprend la dernière ligne qui sert à produire la ligne. Permet de s'appuyer dessus pour le rendu
            "lastModel": dataSource[i - 1]
          };

          // calcul et stock sous-totaux
          var subTotalData = subtotalValues(subtotalDatasource);
          context.subtotalValues[uuid] = subTotalData;
          // permet d'accéder à l'ensemble des données du sous-total dans le template
          subtotalRow.subTotalData = subTotalData;
          if (config.subtotalBefore === true) {
            sortedDatasource.splice(subtotalBeginingPosition, 0, subtotalRow);
          } else {
            sortedDatasource.push(subtotalRow);
          }

          // reinitialise lignes avec meme valeur
          subtotalDatasource = [];
          subtotalBeginingPosition = sortedDatasource.length;
        }
      }
      // la dernière ligne a déjà été ajoutée

      if (i !== dataSource.length) {
        sortedDatasource.push(dataSource[i]);
        subtotalDatasource.push(dataSource[i]);
      }
      i++;
    }
    dataSource = sortedDatasource;
  }
  ctrl.setDatasource = function (_dataSource) {
    dataSource = _dataSource.slice(0); // making copy to be able to change order and stuff.

    if (config.footer) {
      footerCtrl.computeFooterValues();
      if (footerCtrl.hasInlineFooter(config)) {
        dataSource.push({
          __type__: 'footer'
        });
      }
    }
    var initialIndex = context.pagination.first;
    performInitialSort();
    if (config.keepIndexOnReload) {
      setScrollPosition({
        index: initialIndex,
        initial: true
      });
    }
  };
  var subtotalValues = function subtotalValues(subdatasource) {
    var subtotalValues = [];
    ctrl.getContext().columns.filter(function (column) {
      var colDef = column.column;
      return colDef.dataType || colDef.footerReducer && column.column.footer !== false;
    }).forEach(function (column) {
      var footerValue = itFooterAccumulator.accumulate(subdatasource, column.column);
      subtotalValues[column.id] = footerValue;
    });
    return subtotalValues;
  };
  var refreshContent = function refreshContent(keepIndex) {
    var initialIndex = keepIndex ? context.pagination.first : getInitialScrollPosition();
    renderer.clearContent(true);
    setScrollPosition({
      index: initialIndex,
      initial: true
    });
    computeColumnSizing();
    ctrl.applyUsedHeight();
    scrollbar.refresh(true);
  };

  /**
   * Retourne la position initiale dans le cas ou config.initialScroll === true
   *
   * config.initialScroll peut etre :
   *      - l'index d'une colonne
   *      - une fonction retournant l'index d'une colonne
   *      - la reference du modèle d'une colonne.
   *
   * @return number l'index calculé de la position initiale.
   */
  function getInitialScrollPosition() {
    var initialScroll = config.initialScroll;
    if (_.isFunction(initialScroll)) {
      initialScroll = initialScroll(dataSource);
    }
    if (_.isNumber(initialScroll)) {
      return initialScroll;
    } else if (_.isObject(initialScroll)) {
      if (config.type === 'tree') {
        // todo - recherche recusive + gestion ouverts/fermés
        var _position = _.indexOf(dataSource, initialScroll);
        return Math.max(_position, 0);
      }
      var position = _.indexOf(dataSource, initialScroll);
      return Math.max(position, 0);
    } else {
      return 0;
    }
  }
  var findDeepIndex = function findDeepIndex(collection, predicate, recursProperty) {
    var items = [];
    _.each(collection, function (each) {
      return items.push(each);
    });
    return _.indexOf(items, function (value, key, coll) {
      if (predicate(value, key, coll)) {
        return true;
      } else {
        _.each(value[recursProperty], function (each) {
          return items.push(each);
        });
      }
    });
  };

  /**
   * Sets the scroll position on the renderer.
   *
   * @param index      The index of the first row to display
   * @param initial    [optional] true if this is the first rendering of the table
   * @return {boolean} true if the scroll changed the position of the table, false otherwise
   *                   (scrolling up from first row, or bottom from last row for example)
   */
  function setScrollPosition(scrollOptions) {
    if (ctrl.isVisible()) {
      renderer.setScrollPosition(_.extend(scrollOptions, {
        full: fullMode
      }));
    } else {
      lastScrollOptions = scrollOptions;
      renderRequired = true;
    }
    return true; // TODO : implements, checking the first/last index before & after setting scroll position.
  }
  var lastScrollOptions = null;
  function performInitialSort() {
    var initialSubtotal = null;
    if (tableState != null && tableState.subtotalGroup != null) {
      initialSubtotal = tableState.subtotalGroup.column;
    } else {
      initialSubtotal = config.initialSubtotalGroup;
    }
    if (initialSubtotal != null) {
      context.subtotal = {
        column: initialSubtotal
      };
    }
    var initialSort = null;
    if (tableState != null && tableState.sort != null) {
      initialSort = tableState.sort;
    } else {
      initialSort = config.initialSort;
    }
    if (initialSort != null) {
      var sort = normalizeSortOption(initialSort);
      ctrl.sortBy(sort.column, sort.desc, {
        silent: true
      });
    } else {
      // il nous faut  déclencher le tri sur le soustotal puisqu'il n'a pas été déclenché par un tri initial
      if (initialSubtotal) {
        // todo regarder dans le context sort colomn  ?
        var sortOrder = false;
        ctrl.sortBy(initialSubtotal, sortOrder);
      }
      refreshContent(false);
    }
  }

  /**
   * Normalize a sort option to a sort object.
   *
   * Sort option can be of format :
   *  - 'columnId'
   *  - columnIndex
   *  - ["columnId", "desc"]
   *  - ["columnId", true]
   *  - { column : "columnId", desc : true }
   *  - { column : "columnId", desc : "desc"}
   *
   * @param sort
   */
  function normalizeSortOption(sort) {
    var columnId, desc;
    if (_.isNumber(sort) || _.isString(sort)) {
      columnId = sort;
      desc = false;
    } else if (_.isArray(sort)) {
      columnId = sort[0];
      desc = sort[1] === true || sort[1] === "desc";
    } else if (_.isObject(sort)) {
      columnId = sort.column;
      desc = sort.desc === true || sort.desc === "desc";
    } else {
      columnId = 0;
      desc = false;
    }
    return {
      column: columnId,
      desc: desc
    };
  }

  // cleanup / disposal

  ctrl.dispose = function () {
    stopAutoScroll();
    renderer && renderer.clearContent(false);
    unbindVisibilityHandler && unbindVisibilityHandler();
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/infiniTable.js
// module id = 2809
// module chunks = 13